import { makeStyles } from '@material-ui/core'

const SIDEBAR_WIDTH = 200

const useStyles = makeStyles((theme) => ({
  sidebar: {
    width: SIDEBAR_WIDTH,
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderRight: `1px solid ${theme.palette.divider}`,
    overflowY: 'auto',
    padding: theme.spacing(1, 0),
  },
  sidebarCompose: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    margin: theme.spacing(1, 2, 2, 2),
    padding: theme.spacing(1.5, 3),
    borderRadius: 24,
    backgroundColor: theme.palette.gmail.lightBlue,
    cursor: 'default',
    color: theme.palette.text.primary,
  },
  sidebarComposeText: {
    fontSize: 14,
    fontWeight: 500,
  },
  sidebarNav: {
    display: 'flex',
    flexDirection: 'column',
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(0.75, 2),
    borderRadius: '0 24px 24px 0',
    marginRight: theme.spacing(1),
    cursor: 'default',
    color: theme.palette.text.secondary,
  },
  sidebarItemActive: {
    backgroundColor: theme.palette.gmail.lightBlue,
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  sidebarItemIcon: {
    flexShrink: 0,
  },
  sidebarItemLabel: {
    flex: 1,
    fontSize: 13,
  },
  sidebarItemCount: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  sidebarSection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 2),
  },
  sidebarSectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  sidebarSectionItem: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5, 0),
    cursor: 'default',
  },
  sidebarHangoutsBtn: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.75, 2),
    backgroundColor: theme.palette.gmail.blue,
    borderRadius: 4,
    display: 'inline-flex',
    cursor: 'default',
  },
  sidebarHangoutsBtnText: {
    color: theme.palette.white,
    fontSize: 13,
    fontWeight: 500,
  },
}))

export default useStyles
